"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = _interopRequireDefault(require("../../styles/components"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var downIcon = function downIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "13",
    height: "8",
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.6143 1.91895L6.61426 6.91895L1.61426 1.91895",
    stroke: "#677791",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var upIcon = function upIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "12",
    height: "8",
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 6.36352L6 1.36352L11 6.36353",
    stroke: "#677791",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var ListNodeLabel = function ListNodeLabel(_ref) {
  var title = _ref.title,
      badge = _ref.badge,
      icon = _ref.icon,
      selected = _ref.selected,
      collapsed = _ref.collapsed,
      onToggleCollapse = _ref.onToggleCollapse,
      onClick = _ref.onClick;

  var handleMouseHover = function handleMouseHover(e) {
    var containerWidth = e.target.clientWidth;
    var titleElement = e.target.querySelector(".list-item-title");
    var titleElementWidth = titleElement.clientWidth;

    if (titleElementWidth > containerWidth) {
      var maxTransformTime = 15;
      var minTransformTime = 1;
      var percentage = 1 - containerWidth / titleElementWidth;
      var transformTime = percentage * maxTransformTime < 1 ? minTransformTime : percentage * maxTransformTime;

      if (e.type === "mouseenter") {
        titleElement.style.transform = "translateX(calc(-100% + " + containerWidth / 2 + "px))";
        titleElement.style.transition = "transform linear " + transformTime + "s";
      } else if (e.type === "mouseleave") {
        titleElement.style.transform = "";
        titleElement.style.transition = "transform linear 3s";
      }
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_components["default"].ListItem, null, onToggleCollapse && /*#__PURE__*/_react["default"].createElement(_components["default"].ListGroupMarker, {
    onClick: onToggleCollapse
  }, collapsed ? /*#__PURE__*/_react["default"].createElement(_components["default"].ListGroupMark, null, downIcon()) : /*#__PURE__*/_react["default"].createElement(_components["default"].ListGroupMark, null, upIcon())), /*#__PURE__*/_react["default"].createElement(_components["default"].ListItemContent, {
    onClick: onClick,
    selected: selected
  }, /*#__PURE__*/_react["default"].createElement(_components["default"].ListItemTitle, {
    onMouseEnter: handleMouseHover,
    onMouseLeave: handleMouseHover,
    selected: selected
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "list-item-title",
    style: {
      color: selected ? "#339EEC" : "#677791"
    },
    title: title
  }, selected && icon, title)), badge !== undefined && /*#__PURE__*/_react["default"].createElement(_components["default"].ListItemBadge, {
    style: {
      color: selected ? "#339EEC" : "#677791"
    }
  }, badge)));
};

var _default = ListNodeLabel;
exports["default"] = _default;